import React from 'react'
import useSwipe from '../../../hooks/useSwipe';

function ImageBox({ images, activeImage, handleNext, handlePrev }) {
  const handlers = useSwipe(handleNext, handlePrev)
  const displayedLargeImage = images[activeImage] || {};

  return (
    <div {...handlers} className='image-box__container'>
      <img className="image-box__image" src={displayedLargeImage.url} alt={displayedLargeImage.alt} />
    </div>
  )
}

export default ImageBox